import React,{useMemo,useState,useEffect} from 'react';
import MaterialReactTable from 'material-react-table';
import {Box,Button,Table ,Tooltip ,TableCell ,Paper,TableContainer,TableRow,Grid} from '@mui/material';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
 //or use your library of choice here
import { fetchData, postData } from '../../../../redux/apiSlice';
import {  useDispatch } from 'react-redux';
import swal from "sweetalert";
import AuthUser from '../../../../Components/Auth/AuthUser';
import {  useNavigate,useParams} from 'react-router-dom';
import DefaultLayout from '../../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../../Components/Loader/Loader';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from '@mui/material/IconButton';

import { Typography } from '@mui/joy';
import AvailedService  from './AvailedService';
function CompanyMediaServiceActivity(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {http,user} = AuthUser();
    const [rowSelection, setRowSelection] = useState({});
    const rowsSeleted = Object.keys(rowSelection);
    const [data, setData] = useState([]);
    const [columnVisibility, setColumnVisibility] = React.useState({});
    
    const { id } = useParams();
    const [companyId, setCompanyId] = React.useState(() => {
        const isInternalUser = [3, 4, 5].includes(user.roles_id);
        return isInternalUser ? user.company_master_id : id;
    });
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
  
      
    const ContentLayout=
    <>
        <Box sx={{ width: "100%", typography: 'body1' }}>
             <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
                  <IconButton onClick={() => navigate(-1)}>
                 <img src={require("../../../../assets/images/back.png")} alt="back" style={{ width: 30, height: 30 }} />
                </IconButton>
                <Typography level="h3" color="black">Activity Log</Typography>
            </Grid>
            <AvailedService companyId={companyId} handleFreezStart={handleFreezStart} handleFreezStop={handleFreezStop}/>
        </Box>
    </>

    return (
            <div>
                <DefaultLayout content={ContentLayout} />
                {/* loader code start */}
                <div>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                        open={freez}
                    >
                        <Freez />
                    </Backdrop>
                </div>
                {/* loader code end */}
            </div>
        );
}

export default CompanyMediaServiceActivity;